import React from 'react'
import { Link } from 'gatsby'
import icon1 from '../../assets/images/icons/icon1.png'
import icon2 from '../../assets/images/icons/icon2.png'
import icon3 from '../../assets/images/icons/icon3.png'
import shape2 from '../../assets/images/services/service-shape2.png'

const OurFeatures = () => {
    return (
        <div className="boxes-area pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-boxes-item">
                            <div className="icon">
                                <img src={icon1} alt="banner" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Data Visualization
                                </Link>
                            </h3>
                            <p>Highlight key business information in an easy to consume story telling visual dashboards using today's market leading data visualization tools.</p>

                            <Link to="/service-detailsdv" className="default-btn">
                                <i className="flaticon-right"></i>
                                Read More <span></span>
                            </Link>

                            <div className="shape1">
                                <img src={shape2} alt="banner" />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-boxes-item">
                            <div className="icon">
                                <img src={icon2} alt="banner" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Lead to Cash
                                </Link>
                            </h3>
                            <p>Helping you implement Lead to Cash process combining multiple SAP solutions enriched with AI & experience management scenarios.</p>

                            <Link to="/service-detailsa" className="default-btn">
                                <i className="flaticon-right"></i>
                                Read More <span></span>
                            </Link>

                            <div className="shape1">
                                <img src={shape2} alt="banner" />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-sm-3 offset-md-3">
                        <div className="single-boxes-item">
                            <div className="icon">
                                <img src={icon3} alt="banner" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Business Intelligence
                                </Link>
                            </h3>
                            <p>Certified experts helping you create visually appealing business intelligence reports & dashboards in marketing leading BI tools of your choice.</p>

                            <Link to="/service-detailsbi" className="default-btn">
                                <i className="flaticon-right"></i>
                                Read More <span></span>
                            </Link>

                            <div className="shape1">
                                <img src={shape2} alt="banner" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurFeatures